import React from 'react';
import { Link } from 'react-router-dom';
import LandingNav from './LandingNav';
import Footer from './Footer';

const Documentation = () => {
  return (
    <div className="min-h-screen bg-deepspace overflow-x-hidden">
      <LandingNav />

      <section className="relative pt-32 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="absolute inset-0 bg-gradient-to-br from-deepspace via-deepspace-100 to-deepspace-200" />
        <div className="relative max-w-5xl mx-auto">
          <h1 className="text-4xl sm:text-5xl font-bold text-text-primary mb-4">
            Wallet Documentation
          </h1>
          <p className="text-text-secondary text-lg max-w-3xl">
            Learn how to connect, create, import, and recover your wallet securely on Trust Vault LLC.
          </p>
        </div>
      </section>

      <section className="px-4 sm:px-6 lg:px-8 pb-20">
        <div className="max-w-5xl mx-auto space-y-6">
          <div className="bg-dark-card/60 border border-dark-border/60 rounded-2xl p-6">
            <h2 className="text-2xl font-semibold text-text-primary mb-3">Connect Wallet</h2>
            <p className="text-text-secondary leading-relaxed">
              Use Connect Wallet when you already have a Web3 wallet extension. Select your wallet and approve the connection request in your provider.
            </p>
          </div>

          <div className="bg-dark-card/60 border border-dark-border/60 rounded-2xl p-6">
            <h2 className="text-2xl font-semibold text-text-primary mb-3">Create Wallet</h2>
            <p className="text-text-secondary leading-relaxed">
              Creating a wallet requires a 6-digit PIN. After that, save your generated recovery phrase safely. You will need it for recovery if you lose device access.
            </p>
          </div>

          <div className="bg-dark-card/60 border border-dark-border/60 rounded-2xl p-6">
            <h2 className="text-2xl font-semibold text-text-primary mb-3">Import Wallet</h2>
            <p className="text-text-secondary leading-relaxed">
              You can import using recovery phrase, keystore JSON, or private key. Choose wallet type first, then complete the required fields for your import method.
            </p>
          </div>

          <div className="bg-dark-card/60 border border-dark-border/60 rounded-2xl p-6">
            <h2 className="text-2xl font-semibold text-text-primary mb-3">Recovery Tips</h2>
            <p className="text-text-secondary leading-relaxed">
              Keep your recovery details private, never share credentials, and verify URLs before connecting wallets or signing transactions.
            </p>
          </div>

          <div className="text-center pt-4">
            <Link
              to="/auth"
              className="inline-flex px-8 py-3 bg-gradient-to-r from-cyber-blue to-cyber-purple text-white font-semibold rounded-xl"
            >
              Back to Wallet Access
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Documentation;

